import styled from '@emotion/styled';
import { Paper, Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import images from '../UI/images';
import { Box } from '../UI/index';

export default function PropertiesSidebar({ properties, match }) {
	return (
		<ProprtiesSidebar>
			{properties.map((property, index) => {
				if (property.sell.digitalId > 99)
					return (
						<Link to={`${match.url}/${property.id}`} key={property.id}>
							<PropertyBox elevation={3}>
								<Box display="flex" width="350px">
									<Box width="65%" p="15px">
										<Title variant="body1">{property.id}</Title>
										<Typography variant="body1">{property.sell.address}</Typography>
										<Typography variant="body1" color="textSecondary">
											€{property.analysis.details.valuation.eur.toLocaleString()}
										</Typography>
									</Box>
									<ImageBox
										width="35%"
										display="flex"
										alignItems="flex-end"
										imagePath={images[property.index][0]}
									>
										<Status>
											<strong>{property.sell.status}</strong>
										</Status>
									</ImageBox>
								</Box>
							</PropertyBox>
						</Link>
					);
				else return false;
			})}
		</ProprtiesSidebar>
	);
}

const ProprtiesSidebar = styled(Box)`
	position: absolute;
	top: 65px;
	right: 10px;
	& * {
		text-decoration: none;
	}
`;

const PropertyBox = styled(Paper)`
	margin-bottom: 15px;
	& p:not(:last-child) {
		margin-bottom: 1rem;
	}
	transition: background 0.1s ease-in;
	&:hover {
		background: #eee;
	}
`;

const Title = styled(Typography)`
	font-weight: bold;
`;

const ImageBox = styled(Box)`
	background-image: url(${p => p.imagePath});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	padding: 15px;
`;

const Status = styled.div`
	width: 100%;
    background: #b60037;
    border-radius 100px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
	padding: .25rem 0;
	font-size: 12px;
`;
